import PropTypes from "prop-types";
import React, { Component } from "react";
import _ from "lodash";
import BrandPicker from "./brand-picker";
import theme, { themeOptions } from "styles/theme";
import Button from "@material-ui/core/Button";
import shallowequal from "shallowequal";
import Globalize from "globalize";
import fetch from "lib/fetch";
import CatalogAddItem from "components/catalog-add-item";
import ActiveList from "./active-list";
import { merge, $, media } from "glamor";
import classNames from "classnames";
import { VIEWPORT_HD } from "constants/media";
import SummaryFieldsDialog from "components/orders/order/summary-fields-selector";
import * as Sentry from "@sentry/browser"; // error tacking
import RequestAccessHeader from "components/brand-marketplace/brands/request-access-header";
import ViewAs from "./view-as";
import CurrencySelect from "./currency-select";
import SchemaModel from "models/schema";
import { formatCartShippingAddress, StartOrder } from "./start-order";
import { Cart } from "./cart";
import ModePicker from "./mode-picker";
import HeaderNotifications from "./header-notifications";
import Badge from "@material-ui/core/Badge";
import CartIcon from "components/icons/cart";
import CircularProgress from "material-ui/CircularProgress";
import WorkingOrderDraftModal from "components/working-order-draft-modal";
import { DATATEST } from "constants/integration";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { QuickAdd } from "components/product/quick-add/quick-add";
import { SNACK_ID } from "components/product/quick-add/quick-add-popup";
import siteConfig from "site-config";
import { displayingNewColorways } from "helpers/swatch-utils";
import { EditShippingLocationsModal } from "components/orders/order/edit-shipping-locations-modal";
import {
    BuildOrderModal,
    BuildOrderEntry,
    hasBuildOrderEnabled,
    getOrder,
    getShouldShowCartAction,
    getBOShipDates,
    NewShipmentModal,
} from "components/build-order";
import { PromotionModal } from "components/item/promotion-details";
import { canFitInDeliveryWindow } from "helpers/delivery-windows/compare-dates";
import SnackBarItemAddActions from "components/snackbars/snackbar-add-actions";
import moment from "moment";
import { InlineLoading } from "../../content-loading";
import InsightsSidePanelToggleButton from "./insights-side-panel-toggle-button";
import BulkActions from "./bulk-actions";
import { getCartAddSummaryMessage } from "helpers/site-header";
import { SHIPMENT_VIEW } from "containers/legacy-cart/shipment-review-types";
import { PRODUCTS_FILTER } from "constants/brand-settings";
import { isAnUnconnectedBuyerFromMarketplace } from "helpers/marketplace/access-control";
import { MARKETPLACE } from "constants/navigation";

const styles = {
    action: {
        position: "relative",
        marginLeft: "0px",
        marginRight: "8px",
        paddingTop: "10px",
        paddingBottom: "10px",
    },
    flex: {
        display: "flex",
    },
    cartMode: {
        color: themeOptions.palette.grey,
        transition: "height 0.3s ease",
        opacity: 1,
        whiteSpace: "nowrap",
        position: "absolute",
        top: "42px",
        left: "12px",
    },
    menuButton: {
        marginTop: LARGE_BUTTON_TOP_MARGIN + "px",
        marginLeft: "12px",
        marginRight: "12px",
        transition: "margin-top 0.3s ease",
    },
    cartEmptyIcon: {
        fill: themeOptions.palette.canvasColor,
        width: "22px",
        height: "22px",
        marginLeft: "12px",
        float: "left",
    },
    cartIcon: {
        fill: themeOptions.palette.textColor,
    },
    activeCartIcon: {
        marginTop: "6px",
    },
    cartButtonLabel: {
        display: "flex",
        color: "white",
        verticalAlign: "center",
        lineHeight: "25px",
        fontWeight: "bold",
        padding: "0 5px",
    },
    labelContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
    },
    originalCartIcon: {
        fill: themeOptions.palette.darkGrey,
        width: "22px",
        height: "22px",
        marginLeft: "12px",
        // marginTop: "8px",
        float: "left",
    },
    originalCartButton: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        height: "100%",
        lineHeight: "40px",
        minWidth: "44px",
        // margin: "10px 0 0 0",
        whiteSpace: "nowrap",
        fontFamily: "inherit",
        fontSize: 14,
    },
    cartButton: {
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#2fc7be",
        flexWrap: "nowrap",
        minWidth: "124px",
        height: "30px",
        borderRadius: "40px",
        margin: "16px 0 0 0",
        whiteSpace: "nowrap",
    },
    activeCart: {
        backgroundColor: themeOptions.palette.canvasColor,
        height: "100%",
        display: "block",
        margin: "0px",
    },
    cartButtonWithMode: {
        margin: "4px 0 0 0",
    },
    badgeContainer: {
        position: "relative",
        display: "inline-block",
        padding: 11,
        margin: 8,
    },
    badge: {
        display: "flex",
        flexFlow: "row nowrap",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        right: 0,
        fontWeight: 500,
        fontSize: 12,
        width: 24,
        height: 24,
        borderRadius: "50%",
        backgroundColor: "rgb(47, 199, 190)",
        color: "white",
        float: "left",
    },
    totalLabel: {
        color: "#2fc7be",
        margin: "0 8px 0 0",
        padding: "0",
    },
    helpIcon: {
        fill: themeOptions.palette.grey,
        width: "20px",
        height: "20px",
    },
    helpButton: {
        display: "block",
        minWidth: "44px",
        margin: "10px 0 0",
    },
    helpLabel: {
        color: themeOptions.palette.darkGrey,
        paddingRight: "16px",
    },
    loadingCart: {
        marginLeft: "14px",
        marginRight: "18px",
        paddingTop: "23px",
        transition: "padding-top 0.3s ease",
    },
    message: {
        fontSize: 14,
        fontFamily: themeOptions.palette.fontFamily,
    },
    snackActionBtn: {
        fontSize: 14,
        fontFamily: themeOptions.palette.fontFamily,
        textTransform: "none",
        color: themeOptions.palette.accent1Color,
    },
    insightsBtn: {
        paddingTop: "10px",
    },
};

const useStyles = makeStyles({
    label: {
        color: themeOptions.palette.primary1Color,
        paddingRight: "3px",
        paddingLeft: "3px",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        verticalAlign: "middle",
    },
    buttonRoot: {
        padding: 0,
    },
    loadingCartPricing: {
        margin: "0 15px",
        paddingTop: "8px",
    },
});

const OriginalCart = ({
    me,
    openNavSection,
    disabled = false,
    legacyLoaded,
    modePickerOpen,
    onModeCancel,
    onModeSelect,
    onToggleCart,
    addingItems,
    scope,
    cart,
}) => {
    let cartButton = null;
    if (
        !disabled &&
        cart &&
        legacyLoaded &&
        scope.brand &&
        scope.brand._id &&
        me.hasPermission("can_order") &&
        !addingItems &&
        !cart.isFetching &&
        cart.result.length !== 0
    ) {
        const classes = useStyles(); // eslint-disable-line react-hooks/rules-of-hooks
        const orderCart = cart.entities.orders[cart.result];
        const workingOrderMode = orderCart && orderCart.order_flow_type && (
            <div style={styles.cartMode}>{orderCart._mode}</div>
        );

        const countBadge = orderCart && orderCart.line_items_count > 0 && (
            <div data-test={DATATEST.WORKING_ORDER.CART_ITEM_COUNT} style={styles.badgeContainer}>
                <Badge style={styles.badge}>{orderCart.line_items_count}</Badge>
            </div>
        );

        const totalLabel = orderCart && orderCart.line_items_count > 0 && (
            <span data-test={DATATEST.TOTAL_LABEL} style={styles.totalLabel}>
                {orderCart._totalLabel}
            </span>
        );

        const countAndTotal = (
            <span style={styles.labelContainer}>
                {countBadge}
                {cart.isFetchingPricing && <InlineLoading size={25} className={classes.loadingCartPricing} />}
                {!cart.isFetchingPricing && totalLabel}
            </span>
        );

        cartButton = (
            <div style={styles.action}>
                <ModePicker open={modePickerOpen} onRequestClose={onModeCancel} onSelect={onModeSelect} />
                <Button
                    data-test={DATATEST.WORKING_ORDER.HEADER_CART}
                    onClick={onToggleCart}
                    style={{ ...styles.originalCartButton, ...(workingOrderMode && styles.cartButtonWithMode) }}
                    classes={{ label: classes.label, root: classes.buttonRoot }}
                    startIcon={<CartIcon style={styles.originalCartIcon} />}
                >
                    {countAndTotal}
                </Button>
                {workingOrderMode}
            </div>
        );
    } else if (openNavSection === "wholesale" && scope.brand && scope.brand._id && me.hasPermission("can_order")) {
        cartButton = (
            <div style={{ ...styles.action, ...styles.loadingCart }}>
                <CircularProgress
                    size={16}
                    thickness={1}
                    color={themeOptions.palette.grey}
                    data-test="header-cart-loading"
                />
            </div>
        );
    }

    return cartButton;
};

export class SiteHeader extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        viewAs: PropTypes.object,
        router: PropTypes.object.isRequired,
        flags: PropTypes.object.isRequired,
    };

    static propTypes = {
        cart: PropTypes.object.isRequired,
        onCartFetch: PropTypes.func.isRequired,
        onCartItemsFetch: PropTypes.func.isRequired,
        viewAs: PropTypes.object,
        dragging: PropTypes.bool,
        activeList: PropTypes.object.isRequired,
        onSetActiveList: PropTypes.func.isRequired,
        onActiveListAdd: PropTypes.func.isRequired,
        onActiveListRemove: PropTypes.func.isRequired,
        onActiveListFetchEntries: PropTypes.func.isRequired,
        onCreateBuyerProfile: PropTypes.func.isRequired,
        touchDevice: PropTypes.bool,
        viewport: PropTypes.string.isRequired,
        scope: PropTypes.object.isRequired,
        schemas: PropTypes.object,
        schemaIds: PropTypes.array.isRequired,
        sidePanelOpen: PropTypes.bool.isRequired,
        onSetViewAs: PropTypes.func.isRequired,
        onSnackbarAdd: PropTypes.func.isRequired,
        onSnackbarRemove: PropTypes.func.isRequired,
        onRetoggleCart: PropTypes.func.isRequired,
        onClearCompay: PropTypes.func,
        onClearBrand: PropTypes.func.isRequired,
        actionChildren: PropTypes.object,
        cartGridView: PropTypes.object,
        hideHeader: PropTypes.bool,
        requestedConnections: PropTypes.array,
        onSyncFromCart: PropTypes.func,
        onGalleryReset: PropTypes.func,
        onFetchStartOrderCompanies: PropTypes.func,
        companies: PropTypes.object,
        fetchingCompanies: PropTypes.bool,
        companyIds: PropTypes.array,
        hasMoreCompanies: PropTypes.bool,
        location: PropTypes.object,
        hideMsrp: PropTypes.bool.isRequired,
        onToggleHideMsrp: PropTypes.func.isRequired,
        hideWholesale: PropTypes.bool.isRequired,
        onToggleHideWholesale: PropTypes.func.isRequired,
        isBrandPageOfShowSite: PropTypes.bool.isRequired,
        isBrandPage: PropTypes.bool.isRequired,
        isBrandProfilePage: PropTypes.bool.isRequired,
        isSiteManagerPage: PropTypes.bool.isRequired,
        isBrandSiteSettingPage: PropTypes.bool.isRequired,
        isPageTemplate: PropTypes.bool,
        viewingOnMobileApp: PropTypes.bool,
        onCartLoad: PropTypes.func.isRequired,
        displayInsightsToggleButton: PropTypes.bool.isRequired,
    };

    styles = merge(
        $(" .headerShadow", {
            position: "fixed",
            top: "0px",
            left: "0px",
            right: "0px",
            height: theme.appBar.height + "px",
            boxShadow: "0 1px 10px 0 rgba(50,50,50,.2)",
            background: "white",
            zIndex: 998,
            transform: "translateZ(0)",
            WebkitFontSmoothing: "antialiased",
        }),
        $(".isMobile & .headerShadow", {
            paddingLeft: "40px",
        }),
        $(".isMenuPinned & .headerShadow", {
            paddingLeft: "240px",
        }),
        $(".sidePanelOpen .headerShadow", {
            paddingRight: "324px",
        }),
        $(".hidden .headerShadow", {
            top: "-" + theme.appBar.height + "px",
        }),
        $(".action", {
            display: "flex",
        }),
        $(" .headerInner", {
            position: "fixed",
            display: "flex",
            top: "0px",
            left: "0px",
            right: "0px",
            height: theme.appBar.height + "px",
            background: "white",
            zIndex: 1001,
            margin: "0px",
            padding: "0 8px 0 60px",
            transition: "all 0.3s ease",
            transform: "translateZ(0)",
            WebkitFontSmoothing: "antialiased",
        }),
        $(".mobileFixedFix & .headerInner, .mobileFixedFix & .headerShadow", {
            position: "absolute",
        }),
        $(".isMobile & .headerInner", {
            paddingLeft: "40px",
        }),
        $(".isMenuPinned & .headerInner", {
            paddingLeft: "240px",
        }),
        $(".hidden .headerInner", {
            top: "-" + theme.appBar.height + "px",
        }),
        $(" .navLeft", {
            flexGrow: 1,
        }),
        $(" .spacer", {
            width: "1px",
            background: themeOptions.palette.lighterGrey,
            margin: "14px 8px 0",
            height: "32px",
        }),
        $(" .notificationContentLoader", {
            width: "40px",
            position: "relative",
            background: "transparent",
        }),
        media(
            "(min-width: 240px) AND (max-width: 466px)",
            $(" .spacer", {
                display: "none !important",
            }),
        ),
    );

    constructor(props) {
        super(props);

        this.state = {
            title: siteConfig.siteName,
            settingsOpen: false,
            navOpen: false,
            modePickerOpen: false,
            hide: false,
            setActiveCatalogOpen: false,
            addingItems: false,
            workingOrderSummary: false,
            startOrderOpen: false,
            buildOrderOpen: false,
            workingOrder: null,
            selectedCompany: null,
            selectedPromotion: null,
            selectedShippingLocations: null,
            lineItems: null,
            currentItem: null,
            newShipWindows: [],
            boShipDates: null,
            pendingAdds: [],
        };

        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.handleMenuOpen = this.handleMenuOpen.bind(this);
        this.handleCloseSetActiveCatalog = this.handleCloseSetActiveCatalog.bind(this);
        this.handleToggleCart = this.handleToggleCart.bind(this);
        this.handleModeCancel = this.handleModeCancel.bind(this);
        this.handleModeSelected = this.handleModeSelected.bind(this);
        this.hideLegacyCartSummary = this.hideLegacyCartSummary.bind(this);
        this.handleOpenSetActiveCatalog = this.handleOpenSetActiveCatalog.bind(this);
        this.handleStartOrderOpen = this.handleStartOrderOpen.bind(this);
        this.handleStartOrderClose = this.handleStartOrderClose.bind(this);
        this.handleBuildOrderOpen = this.handleBuildOrderOpen.bind(this);
        this.handleBuildOrderClose = this.handleBuildOrderClose.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleRedirectToCart = this.handleRedirectToCart.bind(this);
        this.handleUndoFromSnackBar = this.handleUndoFromSnackBar.bind(this);
        this.handleNewShipmentClose = this.handleNewShipmentClose.bind(this);
        this.handleItemAdd = this.handleItemAdd.bind(this);
        this.handleBulkAdd = this.handleBulkAdd.bind(this);
        this.handleCartAdd = this.handleCartAdd.bind(this);
    }

    showLegacyCartSummary() {
        this.setState({ workingOrderSummary: true });
    }

    hideLegacyCartSummary() {
        this.setState({ workingOrderSummary: false });
    }

    UNSAFE_componentWillMount() {
        const { me, app } = this.context;
        const { scope, cart } = this.props;
        me.on("sync change:using_temp_password", this.handleMeChange, this);

        app.on("change:page", this.handlePageUpdate, this);
        app.on("add-to-cart", this.handleCartAdd, this);
        app.on("remove-from-cart", this.handleCartRemove, this);
        app.on("legacy:add-to-order", this.handleLegacyCartAdd, this);
        app.on("legacy:update-cart", this.handleCartUpdate, this);
        app.on("legacy:update-cart-items", this.handleCartItemsUpdate, this);
        app.on("legacy:working-order-summary", this.showLegacyCartSummary, this);
        app.on("legacy:working-order-edit-shipping-locations", this.handleOpenEditShippingLocationsModal, this);
        app.on("legacy:working-order-draft", this.openDraftDialog, this);
        app.on("legacy:working-order-draft-error", this.closeDraftDialog, this);
        app.on("legacy:working-order-promotion-details", this.handleTogglePromotionModal, this);

        app.on("legacy:working-order", this.handleWorkingOrder, this);
        app.on("legacy:working-order-fail", this.handleWorkingOrder, this);
        app.on("header:actions", this.handlePageActions, this);
        app.on("legacy:disable-quick-add", this.handleDisableQuickAdd, this);
        app.on("legacy:enable-quick-add", this.handleEnableQuickAdd, this);
        app.on("legacy:open-build-order", this.handleBuildOrderOpen, this);

        if (scope.brand && scope.brand._id && cart && !cart.isFetching) {
            this.props.onCartFetch();
        }
    }

    componentWillUnmount() {
        const { me, app } = this.context;
        me.off("sync change:using_temp_password", this.handleMeChange, this);
        app.off("change:page", this.handlePageUpdate, this);
        app.off("add-to-cart", this.handleCartAdd, this);
        app.off("remove-from-cart", this.handleCartRemove, this);
        app.off("legacy:add-to-order", this.handleLegacyCartAdd, this);
        app.off("legacy:update-cart", this.handleCartUpdate, this);
        app.off("legacy:update-cart-items", this.handleCartItemsUpdate, this);
        app.off("legacy:working-order-summary", this.showLegacyCartSummary, this);
        app.off("legacy:working-order-edit-shipping-locations", this.handleOpenEditShippingLocationsModal, this);
        app.off("legacy:working-order", this.handleWorkingOrder, this);
        app.off("legacy:working-order-fail", this.handleWorkingOrder, this);
        app.off("legacy:working-order-draft", this.openDraftDialog, this);
        app.off("legacy:working-order-draft-error", this.closeDraftDialog, this);
        app.off("legacy:disable-quick-add", this.handleDisableQuickAdd, this);
        app.off("legacy:enable-quick-add", this.handleEnableQuickAdd, this);
        app.off("legacy:open-build-order", this.handleBuildOrderOpen, this);
    }

    UNSAFE_componentWillUpdate(_nextProps, nextState) {
        if (nextState.title !== this.state.title) {
            document.title = nextState.title;
        }
    }

    componentDidUpdate() {
        if (this.props.location.pathname?.includes(MARKETPLACE)) {
            this.setState({ title: siteConfig.siteName });
            return;
        }
        const regex = new RegExp("^(/drive|/assortment)", "i");
        if (regex.test(this.props.location.pathname)) {
            return;
        }

        let title = this.props.scope?.brand?.name || siteConfig.siteName;

        const site = this.props.scope?.site;
        const page = this.props.scope?.page;
        if (site && page) {
            title = `${page.title} | ${site.name}`;
        }
        this.setState({ title });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            !shallowequal(this.props, nextProps) ||
            !shallowequal(this.state, nextState) ||
            !shallowequal(this.context, nextContext)
        );
    }

    handlePageActions = (children) => {
        this.setState({ pageActions: children });
    };

    handleLegacyCartAdd(data) {
        const { schemaIds, schemas } = this.props;
        const productSchemaId = schemaIds.find((schemaId) => {
            return schemas[schemaId].type === "product";
        });
        const productRecord = schemas[productSchemaId].toJS();
        const productSchema = new SchemaModel(productRecord);
        const Item = productSchema.getModel();
        const item = new Item({ _id: data._id });
        item.fetch({
            success: () => {
                this.handleCartAdd({ item });
            },
            error: () => {
                this.handleCartAdd({ item });
            },
        });
    }

    handleCartUpdate({ options } = {}) {
        if (this.props.cart && !this.props.cart.isFetching) {
            this.props.onCartFetch(options);
        }
    }

    handleCartItemsUpdate() {
        this.handleCartUpdate();
        this.props.onCartItemsFetch();
    }

    async handleCartAdd(addOptions) {
        if (!addOptions.params) {
            addOptions.params = {};
        }
        const { item, params } = addOptions;

        if (this.props.viewingOnMobileApp) {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.addItemToCartHandler) {
                window.webkit.messageHandlers.addItemToCartHandler.postMessage({
                    item: item._id,
                    params: params,
                });
                return;
            }
        }

        const { cart, scope, entities } = this.props;
        const order = getOrder(cart);
        const useOrderWarehouseFiltering =
            scope?.brand?.hasPreference("set_warehouse_for_linesheets") &&
            scope?.brand?.getPreference("filter_products_by") === PRODUCTS_FILTER.BY_WAREHOUSE_IN_WO;
        if (scope.currencyCode) {
            params.currencyCode = scope.currencyCode;
        }
        if (scope.viewAs) {
            params.companies = [scope.viewAs._id];
        }
        const minimumDeliveryWindow = scope.brand.preferences.get("minimum_delivery_window");
        const { me, flags } = this.context;
        const orderEntity = cart.entities.orders && cart.entities.orders[cart.result];
        const orderFlowType = orderEntity && orderEntity.order_flow_type;
        const isItemWithSizes = Boolean(params?.sizes?.length);
        params.isBuildOrderEnabled = hasBuildOrderEnabled({ scope, me, flags });
        const buildOrderShipDates = addOptions?.shipDates?.length
            ? addOptions?.shipDates
            : orderEntity?.__build_order?.ship_dates;
        if (params.isBuildOrderEnabled && !buildOrderShipDates.length) {
            this.setState((prevState) => ({
                buildOrderOpen: true,
                pendingAdds: [...prevState.pendingAdds, addOptions],
            }));
        } else {
            if (params.isBuildOrderEnabled && buildOrderShipDates?.length && item) {
                const [selectedWarehouseId] = Object.keys(entities?.warehouses ?? {});
                let availability =
                    entities?.itemAvailabilities?.[`${item._id}_${selectedWarehouseId || "none"}`]?.toJS();
                const entitiesWindows = entities?.itemDeliveryWindows;
                if (!availability) {
                    await fetch(`/api/v3.0/item/${item._id}/warehouses-availability?__populate_future_inventory=true`, {
                        method: "GET",
                    })
                        .then((response) => {
                            if (response.ok) {
                                return response.json();
                            } else {
                                throw new Error(
                                    Globalize.formatMessage("Problem updating order. Please refresh and try again."),
                                );
                            }
                        })
                        .then((data) => {
                            [availability] = data.availability;
                        })
                        .catch((error) => {
                            throw new Error(error);
                        });
                } else {
                    availability.delivery_windows = availability.delivery_windows.map(
                        (windowId) => entitiesWindows[windowId],
                    );
                }
                if (isItemWithSizes && params.ship_start && params.ship_end) {
                    availability = {
                        earliest_available_date: params.ship_start,
                        latest_available_date: params.ship_end,
                        delivery_windows: [
                            {
                                start: params.ship_start,
                                end: params.ship_end,
                            },
                        ],
                    };
                }
                const { earliest_available_date, latest_available_date, delivery_windows } = availability ?? {};
                const moment_earliest_available_date = moment.utc(
                    params.fromCatalog && params.ship_start ? params.ship_start : earliest_available_date,
                );
                const moment_latest_available_date =
                    params.fromCatalog && params.ship_end
                        ? moment.utc(params.ship_end)
                        : latest_available_date
                          ? moment.utc(latest_available_date)
                          : undefined;
                const shipDates = getBOShipDates({ buildOrderShipDates });
                const enforceAvailableUntil = scope.brand.preferences.get("enforce_available_until");
                for (const shipDate of shipDates) {
                    const { ship_start, ship_end } = shipDate;

                    if (
                        canFitInDeliveryWindow(
                            moment_earliest_available_date,
                            moment_latest_available_date,
                            minimumDeliveryWindow,
                            moment.utc(ship_start),
                            moment.utc(ship_end),
                            enforceAvailableUntil,
                            shipDates,
                        )
                    ) {
                        params.ship_start = ship_start;
                        params.ship_end = ship_end;
                        params.message = Globalize.formatMessage("Product(s) added to cart");
                        this.handleItemAdd(item, params);
                        return;
                    }
                }

                this.setState((prevState) => ({
                    currentItem: item,
                    newShipWindows: params.fromCatalog
                        ? [
                              {
                                  deliveryWindow: {
                                      start: params.ship_start ?? delivery_windows[0]?.start,
                                      end: params.ship_end ?? delivery_windows[0]?.end,
                                  },
                                  params,
                              },
                          ]
                        : [...prevState.newShipWindows, { deliveryWindow: delivery_windows[0], params }],
                    boShipDates: buildOrderShipDates,
                }));
                return;
            }
            if (scope.brand.hasPreference("new_order_flow") && !orderFlowType && !params.isBuildOrderEnabled) {
                const inventoryStatuses = (item || {}).__inventory || [];
                const tracksInventory = (item || {}).__tracks_inventory || false;
                const canOversell = me.hasPermission("can_oversell");
                const immediateStatuses = ["Immediate", "Future"];

                if (canOversell) {
                    immediateStatuses.push("Oversellable");
                }

                const isValidImmediate = inventoryStatuses.some((inventoryStatus) =>
                    immediateStatuses.includes(inventoryStatus),
                );
                const isValidPrebook = inventoryStatuses.includes("Pre-book");

                if (!item || !tracksInventory || (isValidImmediate && isValidPrebook)) {
                    this.setState((prevState) => ({
                        modePickerOpen: true,
                        pendingAdds: [...prevState.pendingAdds, addOptions],
                    }));
                } else {
                    this.handleModeSelected(isValidPrebook ? "prebook" : "immediate", addOptions);
                }
            } else {
                if (item) {
                    this.handleItemAdd(item, params);
                } else {
                    if (useOrderWarehouseFiltering && order?.selected_warehouse) {
                        params.warehouses = [order.selected_warehouse];
                    }
                    this.handleBulkAdd(params);
                }
            }
        }
    }

    handleCartRemove({ item, toast = true, ids }) {
        if (item) {
            this.props.onCartItemRemove(item, toast);
            this.props.onSetCurrentItem(item._id, true);
        } else {
            this.handleCloseSnack();
            this.props.onCartBulkRemove(ids).then(() => {
                this.props.onCartFetch();
                this.props.onCartItemsFetch();
            });
        }
    }

    handleBulkAdd(params) {
        const { onSnackbarAdd, scope } = this.props;
        params.currencyCode = scope.currencyCode;
        this.setState({ addingItems: true });
        fetch("/api/v2.0/orders/working/line-items/bulk", {
            method: "POST",
            body: JSON.stringify(params),
        })
            .then((response) => {
                if (this.props.cart) {
                    this.props.onCartFetch();
                    this.props.onCartItemsFetch();
                }
                switch (response.status) {
                    case 204:
                        return [];
                    case 304:
                        throw new Error(Globalize.formatMessage("Inactive items cannot be ordered"));
                    default:
                        if (response.status >= 400) {
                            return response.json().then((data) => {
                                throw new Error(data.message || Globalize.formatMessage("Error adding to cart"));
                            });
                        }
                        return response.json();
                }
            })
            .then(({ lineItems, rejectedItemsGroupedByCause }) => {
                if (lineItems.length > 0) {
                    if (displayingNewColorways(scope.brand)) {
                        const ids = lineItems.map((item) => item.product);
                        onSnackbarAdd({
                            message: Globalize.formatMessage("Products added to cart"),
                            id: SNACK_ID,
                            shouldUseLatestSnack: true,
                            action: (
                                <SnackBarItemAddActions
                                    onPrimaryAction={this.handleRedirectToCart}
                                    onSecondaryAction={() => this.handleCartRemove({ ids })}
                                    onClose={this.handleCloseSnack}
                                />
                            ),
                            messageStyle: styles.message,
                        });
                    } else {
                        onSnackbarAdd({ message: Globalize.formatMessage("Items added") });
                    }
                }
                if (!_.isEmpty(rejectedItemsGroupedByCause.warehouse)) {
                    onSnackbarAdd?.({
                        message: getCartAddSummaryMessage({
                            createdEntries: lineItems,
                            rejectedEntries: rejectedItemsGroupedByCause.warehouse,
                        }),
                    });
                }
            })
            .catch(({ message }) => onSnackbarAdd({ message }))
            .then(() => this.setState({ addingItems: false }));
    }
    handleUndoFromSnackBar(item) {
        this.handleCloseSnack();
        this.handleCartRemove({ item });
    }
    handleRedirectToCart() {
        const { router } = this.context;
        this.handleCloseSnack();
        router.push(`/brand/${this.props.scope.brand._id}/cart`);
    }
    handleCloseSnack() {
        this.props.onSnackbarRemove(SNACK_ID);
    }
    handleItemAdd(item, params = {}, shouldUseLatestSnack = true) {
        const { onCartItemAdd } = this.props;
        const { message, isCartOpen, ...rest } = params;
        const snackOptions = {
            id: SNACK_ID,
            shouldUseLatestSnack,
            triggerSnackBar: !isCartOpen,
            action: (
                <SnackBarItemAddActions
                    onPrimaryAction={this.handleRedirectToCart}
                    onSecondaryAction={() => this.handleUndoFromSnackBar(item)}
                    onClose={this.handleCloseSnack}
                />
            ),
            messageStyle: styles.message,
            ...(params.isBuildOrderEnabled && { message: message }),
        };
        onCartItemAdd(item, rest, snackOptions);
    }

    isCartOpen = () => this.context.router.location.pathname.includes("/cart");

    handleModeCancel() {
        this.setState({
            modePickerOpen: false,
            pendingAdds: [],
        });
    }

    handleModeSelected(mode, options) {
        const { pendingAdds } = this.state;
        const { item, params } = options || pendingAdds[0];
        const { cart } = this.props;
        const isModePrebook = mode === "prebook";
        const addItemOptions = { ...params, prebook: isModePrebook };
        if ((pendingAdds.length || options) && cart && cart.result) {
            fetch(`/working/update/${cart.result}`, {
                method: "POST",
                body: JSON.stringify({ order_flow_type: mode }),
            }).then(() => {
                if (pendingAdds.length > 1) {
                    pendingAdds.forEach((add) => {
                        if ((add?.params?.prebook ?? false) === isModePrebook) {
                            this.handleItemAdd(add.item, add.params);
                        }
                    });
                } else if (item) {
                    this.handleItemAdd(item, addItemOptions);
                } else {
                    this.handleBulkAdd(addItemOptions);
                }
            });

            this.setState({
                modePickerOpen: false,
                pendingAdds: [],
            });
        } else {
            throw new Error("Missing required fields");
        }
    }

    handleInventoryChange() {
        this.forceUpdate();
    }

    handlePageUpdate(newState) {
        this.setState(newState);
    }

    handleMenuClose() {
        this.setState({ navOpen: false });
    }

    handleMenuOpen(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({ navOpen: true });
    }

    handleOpenSetActiveCatalog() {
        this.setState({ setActiveCatalogOpen: true });
    }

    handleCloseSetActiveCatalog() {
        this.setState({ setActiveCatalogOpen: false });
    }

    handleMeChange() {
        this.forceUpdate();
    }

    handleWorkingOrder() {
        this.setState({ disabled: false });
        clearTimeout(this.workingOrderTimeout);
    }
    handleDisableQuickAdd() {
        this.setState({ isQuickAddEnabled: false });
    }
    handleEnableQuickAdd() {
        this.setState({ isQuickAddEnabled: true });
    }
    handleWorkingOrderTimeout = () => {
        this.handleWorkingOrder();
        Sentry.captureException(new Error("Failed to load working order"));
    };

    handleToggleCart() {
        const { router } = this.context;
        const { scope, onCartLoad } = this.props;
        if (!router.location.pathname.includes("/cart")) {
            if (
                window.sessionStorage.getItem("lastActivePath") != router.location.pathname ||
                !window.sessionStorage.getItem("lastActivePath")
            ) {
                window.sessionStorage.setItem("lastActivePath", router.location.pathname);
            }
            router.push(`/brand/${scope.brand._id}/cart`);

            //check if setRouteLeaveHook allowed this location change
            if (router.location.pathname.includes("/cart")) {
                this.setState({ disabled: true });
                this.workingOrderTimeout = setTimeout(this.handleWorkingOrderTimeout, 60000);
                onCartLoad();
                this.props.onRetoggleCart(false);
                window.sessionStorage.setItem("forceCartToggle", "false");
            }
        }
    }

    handleStartOrderOpen() {
        const { me } = this.context;
        const { cart, scope, onSnackbarAdd, onSyncFromCart, onGalleryReset } = this.props;
        const connectedCompanies = scope.companies;
        const cartOrderId = cart.result;
        const companyHasMultipleCurrencies = connectedCompanies[0] && connectedCompanies[0].__currency_codes.size > 1;

        const buyer = me.isBuyer() ? scope.company.__buyers.find((uc) => uc.__ref === me._id) : null;
        const populateSalesRep = !scope.brand?.hasPreference("skip_salesrep_assignment") || _.size(buyer?.__reps) === 1;

        if (buyer && populateSalesRep && connectedCompanies.length === 1 && !companyHasMultipleCurrencies) {
            // buyer is only connected to 1 company with 1 currency, just use that one
            const useAdvancedPricing = scope.brand.isAdvancedPricingEnabled(scope);
            let shippingAddresses = [];
            if (scope.company.__addresses) {
                shippingAddresses = Array.isArray(scope.company.__addresses)
                    ? scope.company.__addresses
                    : scope.company.__addresses.toArray();
            }

            const defaultShippingAddress = shippingAddresses.filter((address) => address.__default_shipping)[0];
            const defaultRep = _.head(buyer.__reps);
            const cartUpdate = {
                retailer: {
                    ref: scope.company._id,
                    retailer_name: scope.company.__name,
                    buyer: buyer.__ref,
                    buyer_name: buyer.__name,
                },
                assigned_rep: defaultRep
                    ? {
                          ref: defaultRep.__ref,
                          rep_name: defaultRep.__name,
                          rep_email: defaultRep.__email,
                          employee_code: null,
                      }
                    : null,
                shipping_address: useAdvancedPricing ? formatCartShippingAddress(defaultShippingAddress) : null,
                discount: scope.company.__settings.__default_discount,
                additional_percentage: scope.company.__settings.__default_surcharge,
                currency_code: scope.currencyCode,
                __uninitiated_order: false,
            };
            if (scope.brand?.hasPreference?.("separate_msrp_currency")) {
                cartUpdate.msrp_currency_code = me._activeMSRPCurrency;
            }

            fetch(`/working/update/${cartOrderId}`, {
                method: "POST",
                body: JSON.stringify(cartUpdate),
            })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error(
                            Globalize.formatMessage("Problem starting order. Please refresh and try again."),
                        );
                    }
                })
                .then((data) => {
                    if (useAdvancedPricing) {
                        // product visibility & pricing might be changed after updating cart
                        onGalleryReset();
                    }
                    onSyncFromCart(data, { syncToCart: true });
                })
                .catch((error) => {
                    onSnackbarAdd(error.message);
                });
        } else {
            this.setState({ startOrderOpen: true });
        }
    }

    handleStartOrderClose() {
        this.setState({ startOrderOpen: false });
    }

    handleBuildOrderOpen() {
        this.setState({ buildOrderOpen: true });
    }

    handleBuildOrderClose() {
        this.setState({ buildOrderOpen: false, pendingAdds: [] });
    }

    handleNewShipmentClose() {
        this.setState({ newShipWindows: [], currentItem: null });
    }

    brandIsNotConnected(activeBrandId, connectedBrandIds) {
        return connectedBrandIds.findIndex((brandId) => brandId === activeBrandId) === -1;
    }

    render() {
        const { me, router, app, flags } = this.context;
        const isUnconnectedBuyerFromMarketplace = isAnUnconnectedBuyerFromMarketplace(this.props.scope, flags);

        const {
            activeList,
            cart,
            cartGridView,
            dragging,
            isFetching,
            legacyLoaded,
            onActiveListAdd,
            onActiveListFetchEntries,
            onActiveListRemove,
            onClearCompany,
            onClearBrand,
            onCreateBuyerProfile,
            onMakeAccessRequest,
            onSetActiveList,
            onSetCurrency,
            onSetViewAs,
            onSnackbarAdd,
            onTrackShopBrandClick,
            sidePanelOpen,
            touchDevice,
            viewport,
            scope,
            schemas,
            schemaIds,
            hideHeader,
            requestedConnections,
            onSyncFromCart,
            onToggleViewAsGuest,
            viewAsGuest,
            viewAs,
            onFetchStartOrderCompanies,
            companies,
            fetchingCompanies,
            companyIds,
            hasMoreCompanies,
            hideMsrp,
            hideWholesale,
            onToggleHideMsrp,
            onToggleHideWholesale,
            isBrandPageOfShowSite,
            isBrandPage,
            isBrandProfilePage,
            isSiteManagerPage,
            isBrandSiteSettingPage,
            isPageTemplate,
            displayInsightsToggleButton,
        } = this.props;
        const {
            hide,
            disabled,
            setActiveCatalogOpen,
            modePickerOpen,
            openNavSection,
            addingItems,
            title,
            pageActions,
            startOrderOpen,
            buildOrderOpen,
            currentItem,
            newShipWindows,
            boShipDates,
            pendingAdds,
        } = this.state;
        const { legacyCartEditableSizingGrid } = flags;
        const { company, selectedShippingLocations, lineItems } = this.state;
        const isCartOpen = this.isCartOpen();
        const canOrder = me.hasPermission("can_order");
        const order = getOrder(cart);
        const shouldShowBuildOrder = order && hasBuildOrderEnabled({ scope, me, flags });
        const usingStartOrder = scope.brand && scope.brand.hasPreference("use_start_order") && !shouldShowBuildOrder;
        const autoRepAssign = !scope.brand?.hasPreference("skip_salesrep_assignment");
        const showViewAs =
            !isCartOpen &&
            !usingStartOrder &&
            ((me.account_type !== "buyer" && (openNavSection === "wholesale" || isCartOpen)) ||
                (me.account_type === "buyer" && scope.companies && scope.companies.length > 1) ||
                me.hasPermission("can_hide_pricing"));

        let activeListIcon = null;
        const isQuickAddEnabled =
            !isUnconnectedBuyerFromMarketplace &&
            siteConfig.QUICK_ADD_ENABLED === "true" &&
            scope.brand?.canDisplayProductsToUser(me) &&
            canOrder;

        const shouldShowCartAction = getShouldShowCartAction({ shouldShowBuildOrder, order });

        if (!me.isSignedIn() || hideHeader) {
            return null;
        }

        const shouldHide = hide || router.routes[router.routes.length - 1].hideHeader || dragging;

        const isAdminOrMgmtSection =
            router.location.pathname.includes("/admin?") ||
            router.location.pathname.includes("/management?") ||
            router.location.pathname.includes("/admin/") ||
            router.location.pathname.includes("/management/");

        if (openNavSection === "wholesale" && !isCartOpen && scope.brand && scope.brand._id && !isBrandPageOfShowSite) {
            activeListIcon = (
                <ActiveList
                    activeList={activeList}
                    onSelectList={this.handleOpenSetActiveCatalog}
                    touchDevice={touchDevice}
                />
            );
        }

        const showSearch = me.account_type !== "buyer" || (scope.brand && scope.companies.length > 10);

        if (me.account_type === "buyer") {
            scope.companies.forEach((company) => {
                if (!companies[company._id]) {
                    companies[company._id] = company;
                }

                if (!companyIds.includes(company._id)) {
                    companyIds.push(company._id);
                }
            });
        }

        const uniqueCompanyIds = _.uniq(companyIds);
        const showRequestAccessHeader =
            !isPageTemplate &&
            ((isBrandPage && !isSiteManagerPage && !isBrandSiteSettingPage) || isBrandPageOfShowSite);
        const isGridViewActive =
            isCartOpen && router.location.query?.view === SHIPMENT_VIEW.GRID && !cartGridView.isLoading;
        const isCartBulkActions =
            legacyCartEditableSizingGrid && isGridViewActive && cartGridView.selectedRows?.size > 0;

        // Merge the styles here to access the flags from the context
        const mergedStyles = merge(
            {},
            this.styles,
            $(".sidePanelOpen .headerInner", {
                paddingRight: 0,
            }),
        );

        return (
            <header className={classNames({ hidden: shouldHide, sidePanelOpen })} {...mergedStyles}>
                <div className="headerShadow" />
                <div data-part="topbar" className="headerInner" ref={(ref) => (this._headerRef = ref)}>
                    <div className="navLeft">
                        <BrandPicker
                            activeBrand={scope.brand}
                            onClearCompany={onClearCompany}
                            onSetViewAs={onSetViewAs}
                            page={title}
                            viewport={viewport}
                        />
                    </div>
                    {isCartOpen && shouldShowBuildOrder && (
                        <>
                            <BuildOrderEntry order={order} onOpenBuildOrder={this.handleBuildOrderOpen} />
                            <div className="spacer" />
                        </>
                    )}
                    {pageActions}
                    {pageActions && <div className="spacer" />}
                    {scope.brand && scope.brand._id && showRequestAccessHeader && (
                        <RequestAccessHeader
                            me={me}
                            isGuestBuyer={me.isGuestBuyer()}
                            pathname={router.location.pathname}
                            onTrackShopBrandClick={onTrackShopBrandClick}
                            isFetching={isFetching}
                            onCreateBuyerProfile={onCreateBuyerProfile}
                            onMakeAccessRequest={onMakeAccessRequest}
                            activeBrand={scope.brand}
                            viewport={viewport}
                            canOpenImmediately={true}
                            isPendingConnection={me.isPendingConnection(requestedConnections, scope.brand._id)}
                            isBrandPageOfShowSite={isBrandPageOfShowSite}
                            isBrandProfilePage={isBrandProfilePage}
                            onClearCompany={onClearCompany}
                            onClearBrand={onClearBrand}
                        />
                    )}
                    {openNavSection === "wholesale" &&
                        (showViewAs || (me.account_type === "buyer" && !isCartOpen && !usingStartOrder)) && (
                            <CurrencySelect
                                activeCurrency={scope.currencyCode}
                                availableCurrencies={scope.availableCurrencies}
                                onSetCurrency={onSetCurrency}
                            />
                        )}
                    {openNavSection === "wholesale" && showViewAs && (
                        <ViewAs
                            me={me}
                            activeBrand={scope.brand}
                            viewAs={viewAs}
                            viewAsGuest={viewAsGuest}
                            onSetViewAs={onSetViewAs}
                            onToggleViewAsGuest={onToggleViewAsGuest}
                            scope={scope}
                            onClearCompany={onClearCompany}
                            showSearch={showSearch}
                            hideMsrp={hideMsrp}
                            onToggleHideMsrp={onToggleHideMsrp}
                            hideWholesale={hideWholesale}
                            onToggleHideWholesale={onToggleHideWholesale}
                            router={router}
                        />
                    )}
                    {openNavSection === "wholesale" && !isCartOpen && <HeaderNotifications />}
                    {/* {openNavSection === "wholesale" && showViewAs && <div className="spacer" />} */}
                    {/* {(openNavSection === "wholesale" || isCartOpen) &&
                        viewport === VIEWPORT_HD &&
                        <FlatButton
                            className="nuorder-guide-button"
                            style={styles.helpButton}
                            labelStyle={styles.helpLabel}
                            label={Globalize.formatMessage("Guide")}
                        />} */}
                    {openNavSection === "wholesale" &&
                        !isBrandPageOfShowSite &&
                        viewport === VIEWPORT_HD &&
                        activeListIcon &&
                        !disabled && <div className="spacer" />}
                    {activeListIcon}

                    {displayInsightsToggleButton && (
                        <div style={styles.insightsBtn}>
                            <InsightsSidePanelToggleButton />
                        </div>
                    )}

                    {openNavSection === "wholesale" && !isCartOpen && shouldShowBuildOrder && (
                        <>
                            <div className="spacer" />
                            <BuildOrderEntry order={order} onOpenBuildOrder={this.handleBuildOrderOpen} />
                            <div className="spacer" />
                        </>
                    )}
                    {!isAdminOrMgmtSection &&
                        !isCartOpen &&
                        usingStartOrder &&
                        !isBrandPageOfShowSite &&
                        shouldShowCartAction && (
                            <Cart
                                addingItems={addingItems}
                                cart={cart}
                                disabled={disabled}
                                legacyLoaded={legacyLoaded}
                                canOrder={canOrder}
                                modePickerOpen={modePickerOpen}
                                onModeCancel={this.handleModeCancel}
                                onModeSelect={this.handleModeSelected}
                                onToggleCart={this.handleToggleCart}
                                onHandleStartOrderOpen={this.handleStartOrderOpen}
                                openNavSection={openNavSection}
                                scope={scope}
                                companies={companies}
                            />
                        )}
                    {!isAdminOrMgmtSection &&
                        !isCartOpen &&
                        !usingStartOrder &&
                        !isBrandPageOfShowSite &&
                        shouldShowCartAction && (
                            <OriginalCart
                                addingItems={addingItems}
                                cart={cart}
                                disabled={disabled}
                                legacyLoaded={legacyLoaded}
                                me={me}
                                modePickerOpen={modePickerOpen}
                                onModeCancel={this.handleModeCancel}
                                onModeSelect={this.handleModeSelected}
                                onToggleCart={this.handleToggleCart}
                                openNavSection={openNavSection}
                                scope={scope}
                            />
                        )}
                    {isQuickAddEnabled && (
                        <div
                            style={{
                                marginLeft: 8,
                            }}
                        >
                            <QuickAdd
                                cart={cart}
                                scope={scope}
                                isWorkingOrder={isCartOpen}
                                enabled={openNavSection === "wholesale" ? undefined : this.state.isQuickAddEnabled}
                                onCartAdd={this.handleCartAdd}
                            />
                        </div>
                    )}
                    {setActiveCatalogOpen && (
                        <CatalogAddItem
                            open={setActiveCatalogOpen}
                            onRequestClose={this.handleCloseSetActiveCatalog}
                            onActiveListAdd={onActiveListAdd}
                            onActiveListRemove={onActiveListRemove}
                            onActiveListFetchEntries={onActiveListFetchEntries}
                            onSetActiveList={onSetActiveList}
                            onSnackbarAdd={onSnackbarAdd}
                            viewport={viewport}
                            scope={scope}
                        />
                    )}
                    {startOrderOpen && (
                        <StartOrder
                            open={startOrderOpen}
                            onRequestClose={this.handleStartOrderClose}
                            onToggleCart={this.handleToggleCart}
                            showSearch={showSearch}
                            orderId={cart.result}
                            onSyncFromCart={onSyncFromCart}
                            onSnackbarAdd={onSnackbarAdd}
                            onFetchStartOrderCompanies={onFetchStartOrderCompanies}
                            companyIds={uniqueCompanyIds}
                            companies={companies}
                            user={me}
                            scope={scope}
                            autoRepAssign={autoRepAssign}
                            fetchingCompanies={fetchingCompanies}
                            hasMoreCompanies={hasMoreCompanies}
                            schemas={schemas}
                        />
                    )}
                    {buildOrderOpen && (
                        <BuildOrderModal
                            order={order}
                            orderId={cart?.result}
                            open={true}
                            router={router}
                            onSyncFromCart={onSyncFromCart}
                            onSnackbarAdd={onSnackbarAdd}
                            onSnackbarRemove={this.props.onSnackbarRemove}
                            scope={scope}
                            onCartFetch={this.props.onCartFetch}
                            onRequestClose={this.handleBuildOrderClose}
                            isWorkingOrder={isCartOpen}
                            legacyApp={app.legacy}
                            pendingAdds={pendingAdds}
                            onBulkAdd={this.handleBulkAdd}
                            onCartAdd={this.handleCartAdd}
                        />
                    )}
                    {!!newShipWindows.length && (
                        <NewShipmentModal
                            open={true}
                            onRequestClose={this.handleNewShipmentClose}
                            onCancel={this.handleNewShipmentClose}
                            item={currentItem}
                            windows={newShipWindows}
                            handleItemAdd={this.handleItemAdd}
                            shipDates={boShipDates}
                            onSnackbarAdd={onSnackbarAdd}
                            onSnackbarRemove={this.props.onSnackbarRemove}
                            orderId={cart?.result}
                            scope={scope}
                        />
                    )}
                </div>
                {isCartBulkActions && <BulkActions />}
                <SummaryFieldsDialog
                    id={this.state.workingOrderSummary && "working"}
                    onRequestClose={this.hideLegacyCartSummary}
                    scope={scope}
                    schemas={schemas}
                    schemaIds={schemaIds}
                    me={me}
                />
                <EditShippingLocationsModal
                    open={!_.isEmpty(company)}
                    addresses={company?.addresses}
                    selectedShippingLocations={selectedShippingLocations}
                    lineItems={lineItems}
                    onSave={this.handleSaveSelectedLocations}
                    onCancel={this.handleCloseEditShippingLocationsModal}
                    useDnD
                    showCountWarning
                    canSubmitEmpty
                />
                <PromotionModal
                    selectedPromotion={this.state.selectedPromotion}
                    onChange={this.handleTogglePromotionModal}
                />
                {isCartOpen && this.state.order && (
                    <WorkingOrderDraftModal
                        order={this.state.order}
                        anchorEl={this._headerRef}
                        onClose={this.closeDraftDialog}
                    />
                )}
            </header>
        );
    }

    openDraftDialog = ({ order }) => order && this.setState({ order });

    closeDraftDialog = () => this.setState({ order: null });

    handleTogglePromotionModal = (promotion) => {
        const selectedPromotion = promotion?.payload;
        this.setState({ selectedPromotion });
    };
    handleOpenEditShippingLocationsModal = ({
        payload: { company, selected_shipping_locations, line_items } = {},
    } = {}) =>
        this.setState({ company, selectedShippingLocations: selected_shipping_locations, lineItems: line_items });
    handleCloseEditShippingLocationsModal = () =>
        this.setState({ company: null, selectedShippingLocations: null, lineItems: null });
    handleSaveSelectedLocations = (selectedLocations) => {
        this.handleCloseEditShippingLocationsModal();
        this.context.app.legacy.sendMessage({
            payload: {
                action: "selected-locations",
                selected_shipping_locations: selectedLocations,
            },
        });
    };
}

const LARGE_BUTTON_TOP_MARGIN = (theme.appBar.height - 48) / 2;

export default Cart;
